import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";

// modules
import { FlexLayoutModule } from "@angular/flex-layout";
import { ToastrModule } from "ngx-toastr";
import { MaterialModule } from "./material.module";

// components
import { AlloySdkComponent } from "./components/alloy-sdk/alloy-sdk.component";
import { ConfirmationDialogComponent } from "./components/confirmation-dialog/confirmation-dialog.component";
import { ErrorDialogComponent } from "./components/error-dialog/error-dialog.component";
import { IdleDialogComponent } from "./components/idle-dialog/idle-dialog.component";
import { LoadingDialogComponent } from "./components/loading-dialog/loading-dialog.component";
import { SessionIdleComponent } from "./components/session-idle/session-idle.component";
import { SettingTooltipComponent } from './components/setting-tooltip/setting-tooltip.component';
import { TooltipInputComponent } from './components/tooltip-input/tooltip-input.component';

// services
import { AddressVerificationControllerService } from "skyhopper-api";
import { CoreService } from "./services/core.service";
import { ErrorDialogService } from "./services/error-dialog.service";
import { ErrorService } from "./services/error.service";
import { LoadingDialogService } from "./services/loading-dialog.service";
import { SessionStorageService } from "./services/session-storage.service";

// pipes
import { MaskPipe } from "./pipe/mask.pipe";
import { SafePipe } from "./pipe/safe.pipe";

import { NgxMaskModule } from "ngx-mask";
import { NgxPlaidLinkModule } from "../plaid/public_api";
import { DndDirective } from "./Directives/dnd.directive";
import { ToolTipRendererDirective } from "./Directives/tool-tip-renderer.directive";
import { AlloyEvaluateComponent } from "./components/alloy-evaluate/alloy-evaluate.component";
import { AlloySdkFrameComponent } from "./components/alloy-sdk-frame/alloy-sdk-frame.component";
import { FundingComponent } from "./components/funding/funding.component";
import { InvitationErrorComponent } from "./components/invitation-error/invitation-error.component";
import { MaintenanceBannerComponent } from "./components/maintenance-banner/maintenance-banner.component";
import { PageBreakComponent } from "./components/page-break/page-break.component";
import {AlloyJourneyComponent} from "./components/alloy-journey/alloy-journey.component";
import { SocureWebhooksComponent } from "./components/socure-webhooks/socure-webhooks.component";
import { SanitizePipe } from "./pipe/sanitize.pipe";
import { CustomValidators } from "./validators/custom-validator";
import { UsernameValidator } from "./validators/username-validator";

const sharedComponents = [
  LoadingDialogComponent,
  ErrorDialogComponent,
  SettingTooltipComponent,
  IdleDialogComponent,
  SessionIdleComponent,
  ConfirmationDialogComponent,
  AlloyEvaluateComponent,
  MaintenanceBannerComponent,
  SocureWebhooksComponent,
  InvitationErrorComponent,
  AlloySdkComponent,
  AlloySdkFrameComponent,
  PageBreakComponent,
  FundingComponent,
  AlloyJourneyComponent,
  PageBreakComponent
];

@NgModule({
    declarations: [...sharedComponents, MaskPipe, SafePipe, SanitizePipe, TooltipInputComponent, ToolTipRendererDirective, DndDirective],
  imports: [CommonModule, RouterModule, MaterialModule, ToastrModule.forRoot(), ReactiveFormsModule, FlexLayoutModule, NgxMaskModule, NgxPlaidLinkModule],
    exports: [...sharedComponents, FormsModule, ReactiveFormsModule, TooltipInputComponent, ToolTipRendererDirective, DndDirective, MaskPipe, SafePipe, SanitizePipe],
    providers: [ErrorDialogService, LoadingDialogService, ErrorService, UsernameValidator, CustomValidators, SessionStorageService, CoreService, AddressVerificationControllerService]
})
export class SharedModule {
}
